// extracted by mini-css-extract-plugin
export default {"fallbackContainer":"SuspenseWithFlag_fallbackContainer__fnEGK","childrenContainer":"SuspenseWithFlag_childrenContainer__ag3j+"};